<template>
  <div class="field">
    <label class="label" v-if="to.label" :for="to.id ? to.id : null">{{
      to.label
    }}</label>
    <div class="control has-icons-right mt-2">
      <chrome-picker v-model="colors" @input="onChange" />
      <span class="icon is-small is-right" v-if="hasError">
        <i class="fa fa-warning"></i>
      </span>
    </div>
    <error-display :form="form" :field="field.key"></error-display>
  </div>
</template>

<script>
import { Chrome } from "vue-color";
import baseField from "./baseField";

export default {
  mixins: [baseField],
  components: {
    "chrome-picker": Chrome
  },
  data() {
    return {
      colors: {
        hex: this.model[this.field.key]
      }
    };
  },
  methods: {
    onChange(e) {
      this.model[this.field.key] = this.colors.hex;
      this.$set(this.form[this.field.key], "$dirty", true);
      this.runFunction("onChange", e);
      if (this.to.inputType === "file") {
        this.$set(
          this.model,
          this.field.key,
          this.$el.querySelector("input").files
        );
      }
    }
  }
};
</script>
